import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import Footer from "../Home/Components/footer/Footer";
import "./Gallery.css";

import { API_BASE_URL } from "../../config";

const Gallery = () => {
    const navigate = useNavigate();
    const [folders, setFolders] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "auto" });
        fetch(`${API_BASE_URL}/api/gallery/folders`)
            .then((r) => r.json())
            .then(setFolders)
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    return (
        <>
            <Navbar />
            <div className="gallery-page">
                {/* Hero */}
                <div className="gallery-hero">
                    <div className="gallery-hero-content">
                        <span className="gallery-hero-tag">Our Gallery</span>
                        <h1>Moments That Matter</h1>
                        <p>Explore memories, milestones, and everyday magic at Anubhava Montessori.</p>
                    </div>
                    <div className="gallery-hero-deco">
                        <div className="deco-circle c1"></div>
                        <div className="deco-circle c2"></div>
                        <div className="deco-circle c3"></div>
                    </div>
                </div>

                {/* Folders grid */}
                <div className="gallery-folders-section">
                    {loading ? (
                        <div className="gallery-loading">Loading galleries...</div>
                    ) : folders.length === 0 ? (
                        <div className="gallery-empty">
                            <i className="fa-solid fa-images"></i>
                            <h3>Gallery coming soon!</h3>
                            <p>Check back for photos and memories.</p>
                        </div>
                    ) : (
                        <div className="gallery-folders-grid">
                            {folders.map((folder) => (
                                <div
                                    key={folder._id}
                                    className="gallery-folder-card"
                                    onClick={() => navigate(`/gallery/${folder.folderId}`)}
                                >
                                    <div className="gallery-folder-thumb">
                                        {folder.thumbnail ? (
                                            <img src={folder.thumbnail} alt={folder.name} loading="lazy" />
                                        ) : (
                                            <div className="folder-thumb-placeholder">
                                                <i className="fa-solid fa-image"></i>
                                            </div>
                                        )}
                                        <div className="folder-thumb-overlay">
                                            <i className="fa-solid fa-images"></i>
                                            <span>View Gallery</span>
                                        </div>
                                    </div>
                                    <div className="gallery-folder-info">
                                        <h3>{folder.name}</h3>
                                        {folder.displayDate && (
                                            <span className="folder-date">
                                                <i className="fa-regular fa-calendar"></i> {folder.displayDate}
                                            </span>
                                        )}
                                        {folder.description && <p>{folder.description}</p>}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Gallery;